import React, { JSX } from 'react';
import {
  Text,
  RichText,
  Field,
  LinkField,
  Link,
  ImageField,
} from '@sitecore-jss/sitecore-jss-nextjs';
import Image from '../atoms/Image';
import { ItemValue } from 'components/types/ListItem';
import { classNames } from 'assets/utils/helper';
import { getMarginSize } from 'assets/utils/getMarginSize';
import { StyleguideComponentProps } from 'lib/component-props';

type SpotlightLocationsProps = StyleguideComponentProps & {
  fields: {
    MarginSize: {
      fields: {
        heading: {
          value: string;
        };
      };
    };
    BaseImage: ImageField;
    BaseHeadline: Field<string>;
    BaseDescription: Field<string>;
    BaseLink: LinkField;
    BaseLinkType: ItemValue;
    BasePhoneNumber: Field<string>;
  };
};

const SpotlightLocations = (props: SpotlightLocationsProps): JSX.Element => {
  if (!props || !props.fields) {
    return <div></div>;
  }

  const marginSize = getMarginSize(
    props?.fields?.MarginSize?.fields?.heading?.value
  );
  const phoneNumber = props.fields?.BasePhoneNumber?.value?.trim();
  const linkText = props.fields?.BaseLink?.value?.text?.trim();
  const linkClassName = props.fields?.BaseLinkType?.name
    ? `btn-mobile-fw btn-${props.fields?.BaseLinkType?.name.toLowerCase()}`
    : 'btn-mobile-fw';

  return (
    <div
      className={classNames('overhauled', marginSize)}
      id={`spotlight-locations-${props.rendering?.uid}`}
    >
      <div className="spotlight locations jss-inner-container">
        <div className="bg-secondary">
          <div className="content-wrapper">
            {props.fields.BaseImage?.value?.src && (
              <div className="img-container">
                <Image
                  imageUrl={props.fields.BaseImage?.value?.src as string}
                  alt={
                    (props.fields.BaseImage?.value?.alt as string) != ''
                      ? (props.fields.BaseImage?.value?.alt as string)
                      : 'Image'
                  }
                  aditionalClass="location-img"
                />
              </div>
            )}
            <div className="inner-content inner-side-spacing">
              {props.fields?.BaseHeadline?.value && (
                <Text
                  tag="h2"
                  className="headline"
                  field={props.fields.BaseHeadline}
                />
              )}
              {props.fields?.BaseDescription?.value && (
                <RichText
                  tag=""
                  className="description"
                  field={props.fields.BaseDescription}
                />
              )}
              {phoneNumber ? (
                <a
                  href={`tel:${phoneNumber}`}
                  className={linkClassName}
                >
                  {linkText || phoneNumber}
                </a>
              ) : (
                props.fields?.BaseLink?.value?.href &&
                props.fields?.BaseLinkType?.name && (
                  <Link
                    field={props.fields?.BaseLink?.value}
                    className={linkClassName}
                  />
                )
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SpotlightLocations;
